export default __webpack_public_path__ + "static/media/teachings_of_freedom.20aba14d.png";